import { Injectable } from '@angular/core';
import { HelpersService } from '@app/shared/services/helpers.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ErrorMessages } from '@app/shared/constants';

interface RewardPercent {
  [provinceCode: string]: number; // e.g.{ default: 1, QC: 2 }
}

export interface GlobalConfiguration {
  byoa_charge_amount: string | number;
  return_centre_renewal: string | number;
  maximum_wallet_fund_attempts: number;
  wallet_fund_time_window: number; // in seconds
  signe_local_margin: number;
  signe_local_courier_modifier: number;
  allow_first_time_discount: number;
  first_time_discount: number;
  allow_referral:  number,
  business_referral_amount: number,
  reward_percent: string | RewardPercent;
  min_payout_amount: number;
  allow_reward: number;
  check_blacklist: boolean;
  external_api_wallet_minimum: number;
  external_api_wallet_margin_percent: number;
  stop_acc_ecommerce_calls: boolean;
  recon_needs_attention_company_threshold?: number | string;
  recon_needs_attention_shipment_threshold?: number | string;
  recon_pending_light_min_total?: number | string;
}

@Injectable({ providedIn: 'root' })
export class GlobalConfigurationService {
  constructor(
    private helperService: HelpersService,
    private http: HttpClient
  ) {}

  public getGlobalConfiguration(): Observable<GlobalConfiguration> {
    return this.http
      .get(`${environment.APP_SERVICES_URL}/admin/global_configuration`)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) =>
          throwError(error.error || ErrorMessages.UNEXPECTED)
        )
      );
  }

  public updateGlobalConfiguration(params: GlobalConfiguration): Observable<GlobalConfiguration> {
    return this.http
      .put(`${environment.APP_SERVICES_URL}/admin/global_configuration`, params)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) =>
          throwError(error.error || ErrorMessages.UNEXPECTED)
        )
      );
  }
}
